import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { localStorageStrategy, persistState } from '@ngneat/elf-persist-state';

type AuthProps = {
  token: string | null;
  refreshToken: string | null;
};

const defaultValues: AuthProps = {
  token: null,
  refreshToken: null,
};

const authStore = createStore(
  { name: 'auth' },
  withProps<AuthProps>(defaultValues)
);

persistState(authStore, {
  key: 'auth',
  storage: localStorageStrategy,
  preStoreInit: (value: AuthProps) => {
    return value;
  },
});

@Injectable({ providedIn: 'root' })
export class AuthRepository {
  token$ = authStore.pipe(select((state) => state.token));
  refreshToken$ = authStore.pipe(select((state) => state.refreshToken));

  setToken(token: AuthProps['token']) {
    authStore.update((state) => ({ ...state, token }));
  }

  setRefreshToken(refreshToken: AuthProps['refreshToken']) {
    authStore.update((state) => ({ ...state, refreshToken }));
  }

  resetStore() {
    authStore.reset();
  }
}
